var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43.716,
    height: 36.273,
    viewBox: "0 0 43.716 36.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f48e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fde636"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4125",
    "data-name": "Path 4125",
    d: "M43.716,37.456a2.637,2.637,0,1,0-4.931,1.3l-2.38,2.38a20.3,20.3,0,0,1-1.152-6.216,2.638,2.638,0,1,0-3.4-.515,42.876,42.876,0,0,1-5.026,6.687,61.648,61.648,0,0,1-3.316-11.121,2.637,2.637,0,1,0-3.309,0,61.564,61.564,0,0,1-3.316,11.122A42.777,42.777,0,0,1,11.862,34.4a2.637,2.637,0,1,0-3.4.515,20.213,20.213,0,0,1-1.152,6.216L4.931,38.754a2.637,2.637,0,1,0-3.383,1.1c.935,4.748,2.173,11.559,2.173,13.1V60.11a1.445,1.445,0,0,0,1.445,1.445H38.55a1.445,1.445,0,0,0,1.445-1.445V52.956c0-1.541,1.238-8.352,2.173-13.1A2.639,2.639,0,0,0,43.716,37.456ZM6.529,44.44a1.446,1.446,0,0,0,2.044,0c1.372-1.372,2.074-3.833,2.433-6.041a51.838,51.838,0,0,0,5.061,6.041,1.446,1.446,0,0,0,2.044,0c1.456-1.456,2.79-5.443,3.747-9,.957,3.553,2.291,7.54,3.747,9a1.445,1.445,0,0,0,2.044,0A51.838,51.838,0,0,0,32.71,38.4c.359,2.209,1.061,4.669,2.433,6.041a1.446,1.446,0,0,0,2.044,0l1.434-1.434c-.537,2.871-1.155,6.375-1.4,8.505H6.5c-.249-2.131-.868-5.634-1.4-8.505ZM37.1,58.664H6.612V54.4H37.1Z",
    transform: "translate(0 -25.281)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.bc146a98513345d8793efe43ed637e65.svg";
export { ForwardRef as ReactComponent };